(ns practitest.frontend.forms3.global-field-form
  (:require [practitest.frontend.common.re-frame :refer [partial-dispatch partial-subscribe partial-dispatch-sync]]
            [practitest.frontend.forms3.entity-form.forms :as forms3]
            [practitest.frontend.forms3.custom-field-form-common :as cf-form-common]
            [practitest.frontend.components.forms :as forms-components]
            [goog.object :as gobj]
            [practitest.frontend.global-fields-settings.events :as global-field-events]
            [practitest.frontend.global-fields-settings.subs :as global-fields-subs]
            [practitest.frontend.global-fields-settings.common :as global-fields-common]
            [practitest.frontend.common.mixpanel :as mixpanel]
            [re-frame.core :as re-frame]))

(def ^:private keys-cfg
  {:name            :global-field-name
   :format          :global-field-format
   :parent-list     :global-parent-list
   :possible-values :global-field-possible-values
   :entity-table    :global-field-entity
   :select-projects :global-field-select-projects})

(defn- global-field-fields-props [{:keys [edit? field-format]}]
  (cf-form-common/fields-props
   {:edit? edit?
    :field-format field-format
    :list-field-names @(re-frame/subscribe [:global-fields-settings/list-field-names])
    :on-clear-dependent-fields #(re-frame/dispatch [::global-field-events/clear-dependent-fields
                                                    global-fields-common/global-field-form-id
                                                    [:global-field-possible-values]])
    :keys-cfg keys-cfg
    :name-field-type :glb-prefixed-text}))

(re-frame/reg-sub
 ::global-fields-props
 (fn [_db [_ edit? field-format field-name]]
   (first (filter #(= (:field-name %) field-name) (global-field-fields-props {:edit? edit? :field-format field-format})))))

(defn- global-fields-form-props [{:keys [edit? field-format]}]
  {:get-field-props (partial-subscribe [::global-fields-props edit? field-format])
   :get-form-state  (partial-subscribe [::forms3/form-state global-fields-common/global-field-form-id])
   :set-form-state  (partial-dispatch [::forms3/set-form-state global-fields-common/global-field-form-id])

   :get-field-state (partial-subscribe [::forms3/field-state global-fields-common/global-field-form-id])
   :set-field-state (partial-dispatch-sync [::forms3/set-field-state global-fields-common/global-field-form-id])})

(defn force-form-validation! [{:keys [edit? field-format]}]
   (let [{:keys [set-form-state
                 get-form-state
                 get-field-props]} (global-fields-form-props {:keys [edit? field-format]})
         new-form-state (let [form-state @(get-form-state)]
                          (reduce
                           (fn [form-state field]
                             (update-in form-state [:fields field]
                                        (fn [field-state]
                                          (let [props @(get-field-props field)]
                                            (assoc field-state :errors (forms-components/validate-all (:validators props) (:value field-state)))))))
                           form-state
                           (map :field-name (global-field-fields-props {:edit? edit? :field-format field-format}))))]
     (set-form-state new-form-state)
     (into {}
           (comp
            (map (fn [[field field-state]]
                   (if (seq (:errors field-state))
                     [field (:errors field-state)]
                     nil)))
            (remove nil?))
           (:fields new-form-state))))

(defn- on-delete-item [edit? form-data]
  (fn [item]
    (mixpanel/track
     "Delete_Global_Field_Value"
     {"Type" (get-in form-data [:global-field-format :value])})
    (if edit?
      (re-frame/dispatch [::global-field-events/check-item-value-usage item])
      (re-frame/dispatch [::global-field-events/delete-item-from-create-form item]))))

(defn- on-add-item [form-data]
  (fn [_]
    (mixpanel/track
     "Adding_Global_Field_Value"
     {"Type" (get-in form-data [:global-field-format :value])})))

(defn- on-edit-item [edit? form-data]
  (when edit?
    (fn [item]
      (mixpanel/track
       "Rename_Global_Field_Value"
       {"Type" (get-in form-data [:global-field-format :value])})
      (re-frame/dispatch [::global-field-events/open-rename-value-modal item nil]))))

(defn- linked-on-delete-item [edit? form-data]
  (fn [parent-item]
    (fn [item]
      (mixpanel/track
       "Delete_Global_Field_Value"
       {"Type" (get-in form-data [:global-field-format :value])})
      (if edit?
        (re-frame/dispatch [::global-field-events/check-item-value-usage item (keyword parent-item)])
        (re-frame/dispatch [::global-field-events/delete-item-from-create-form item (keyword parent-item)])))))

(defn- linked-on-edit-item [edit? form-data]
  (fn [parent-item]
    (when edit?
      (fn [item]
        (mixpanel/track
         "Rename_Global_Field_Value"
         {"Type" (get-in form-data [:global-field-format :value])})
        (re-frame/dispatch [::global-field-events/open-rename-value-modal item (keyword parent-item)])))))

(defn- render-global-field-form [{:keys [edit?]}]
  (let [form-data @(re-frame/subscribe [::global-fields-subs/global-fields-form-data])
        field-format (get-in form-data [:global-field-format :value])
        loading? @(re-frame/subscribe [:global-fields-settings/form-loading?])
        parent-list (get-in form-data [:global-parent-list :value])
        parent-list-items @(re-frame/subscribe [:global-fields-settings/list-items parent-list])
        action-in-progress? @(re-frame/subscribe [::global-fields-subs/possible-value-action-in-progress?])
        form-props (global-fields-form-props {:edit? edit? :field-format field-format})]
    (cf-form-common/render-form-body
     {:edit? edit?
      :field-format field-format
      :loading? loading?
      :fields-props-list (global-field-fields-props {:edit? edit? :field-format field-format})
      :form-props form-props
      :keys-cfg keys-cfg
      :parent-list-items (when parent-list parent-list-items)
      ;; possible-values-list needs flat callbacks; linked-values-list needs
      ;; callbacks curried per parent-item. Only one of the two ever renders
      ;; for a given field-format (see render-form-body's cond), so it's safe
      ;; to pick the shape here based on which branch will actually run.
      :on-delete-item (if (= field-format "linkedlist")
                        (linked-on-delete-item edit? form-data)
                        (on-delete-item edit? form-data))
      :on-add-item (on-add-item form-data)
      :on-edit-item (if (= field-format "linkedlist")
                      (linked-on-edit-item edit? form-data)
                      (on-edit-item edit? form-data))
      :show-select-projects? true
      :entity-linker-opts nil
      :always-editable-values? false
      :action-in-progress? action-in-progress?})))

(defn- global-field-form-edit []
  (let [global-field-id @(re-frame/subscribe [::global-fields-subs/global-field-id])
        global-fields @(re-frame/subscribe [:global-fields-settings/get-all-fields])
        edit-global-field (first (filter (fn [field] (= (str (:id field)) (str global-field-id))) global-fields))]
    (if edit-global-field
      (re-frame/dispatch [::global-field-events/init-form-values edit-global-field])
      ;; redirect to permission error page when account does not have such global field
      (.replace (gobj/get js/document "location") "/permission_error"))
    (fn []
      [render-global-field-form {:edit? true}])))

(defn global-field-form [{:keys [edit?]}]
  (let [init-done? @(re-frame/subscribe [:global-fields-settings/init-complete?])]
    (when init-done?
      (if edit?
        [global-field-form-edit]
        [render-global-field-form {:edit? edit?}]))))
